module.exports = {
      id: "icon-search-module-check-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-search-module-check",
      toString: function () {
        return this.url;
      }
    }